/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card, Col, Form, InputGroup, Pagination, Row, } from 'react-bootstrap';
import {
  FaCaretRight, FaFileExcel, FaPlus, FaMagnifyingGlass, FaXmark, FaFloppyDisk, FaPencil,
  FaAngleLeft, FaAngleRight, FaAnglesLeft, FaAnglesRight
} from 'react-icons/fa6';
import { http, layout, notification, store } from '../../helpers';
import FilterSaveModal from '../modals/filter-save';
import { auth } from '@/services/auth';

export default function FilterAndPagination({
  manager, page, pages, total, placeholder, children, custom, handleNew, exportable, hideSaved, hideClear, ignoreMirror, paginationCallback, config
}) {
  const user = auth.store.logged.get();
  const [term, setTerm] = useState(manager?.filter?.term);
  const [filter, setFilter] = useState();
  const [filters, setFilters] = useState();
  const [selectedFilter, setSelectedFilter] = useState();
  const [showFilterSaveModal, setShowFilterSaveModal] = useState();
  const [accordion, setAccordion] = useState(window.screen.width < 500 ? config?.accordion ?? '' : 'filters');

  const limits = config?.limits ?? [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  const labels = {
    record: config?.record ?? 'registro',
    records: config?.records ?? 'registros',
    empty: config?.empty ?? 'Nenhum registro encontrado'
  };

  const onSubmit = (e) => {
    e.preventDefault();
    manager.filterIt('term', term);
    layout.focus('term');
  };

  const handleClearFilter = (e) => {
    notification.confirm('Deseja realmente limpar os filtros?', () => {
      setTerm('');
      store.filter.set({}, manager.cacheKey);
      layout.loading(true);
      window.location.reload();
    });
  };

  const handleSaveFilter = (e) => {
    setShowFilterSaveModal(true);
  };

  const handleCancelSaveFilter = (e) => {
    setShowFilterSaveModal(false);
  };

  const handleUpdate = (result) => {
    if (!filters) {
      return;
    }
    filters.forEach((element, index) => {
      if (element._id === result._id) {
        filters[index] = result;
      }
    });
  };

  const handleInputChange = ({ target }) => {
    const regex = /[{}'"]/;
    if (!target.value.match(regex)) {
      setTerm(target.value);
    }
    if (!target.value || target.value.match(regex)) {
      manager.filter.term = '';
    }
  };

  const handleFilter = ({ target }) => {
    const { value } = target;
    setFilter(value);
    if (!value) {
      return;
    }
    setSelectedFilter(filters.find((el) => el._id === value));
    if (!selectedFilter) {
      return;
    }
    store.filter.set(selectedFilter.data, selectedFilter.key);
    manager.load();
  };

  const hasFilter = () => {
    let count = 0;
    for (const key of Object.keys(manager.filter)) {
      if (manager.filter[key]) {
        ++count;
      }
    }
    return count > 0;
  };

  const first = () => {
    manager.load(1, paginationCallback);
    manager.setPage(1);
  };

  const previous = () => {
    const prevPage = page > 1 ? page - 1 : 1;
    manager.load(prevPage, paginationCallback);
    manager.setPage(prevPage);
  };

  const next = () => {
    const nextPage = page < pages ? page + 1 : pages;
    manager.load(nextPage, paginationCallback);
    manager.setPage(nextPage);
  };

  const last = () => {
    manager.load(pages, paginationCallback);
    manager.setPage(pages);
  };

  const goto = () => {
    manager.load(parseInt(page), paginationCallback);
  };

  useEffect(() => {
    if (hideSaved) { return; }
    http.get(`/filters?key=${manager.cacheKey}`, (result) => {
      setFilters([]);
      if (result) {
        setFilters(result);
      }
    });
  }, []);

  const main = () => handleNew && (
    <Row className="mt-1 mb-1 not-printable">
      <Col className="text-center d-grid gap-2">
        <Button size={config?.size ?? 'sm'} className="shadow-sm" onClick={handleNew}>
          <FaPlus className="me-1" />
          Adicionar
        </Button>
      </Col>
    </Row>
  );
  const records = () => !config?.ignoreRecords && (
    <Row>
      <Col className="text-center">
        {total > 0 && (
          <>
            <strong>{total || 0}</strong>
            <span className="ms-1">{`${total > 1 ? labels.records : labels.record} em `}</span>
            <strong>{pages || 0}</strong>
            {`${pages > 1 ? ' páginas' : ' página'}`}
          </>
        )}
      </Col>
    </Row>
  );
  const paginate = () => (
    <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap not-printable my-2">
      <div className="d-flex align-items-center gap-1">
        <Button
          variant="light"
          className="btn-pagination-nav rounded-circle p-0 d-flex align-items-center justify-content-center"
          onClick={first}
          disabled={page === 1}
          title="Primeira Página"
        >
          <FaAnglesLeft size={13} />
        </Button>
        <Button
          variant="light"
          className="btn-pagination-nav rounded-circle p-0 d-flex align-items-center justify-content-center"
          onClick={previous}
          disabled={page === 1}
          title="Página Anterior"
        >
          <FaAngleLeft size={13} />
        </Button>
      </div>

      <div className="d-flex align-items-center gap-2">
        {!config?.ignoreRecords && (
          <InputGroup size="sm" className="pages-input-group">
            <Form.Control
              type="number"
              value={page}
              min={1}
              max={pages}
              onChange={(e) => manager.setPage(e.target.value)}
              disabled={pages === 1}
              className="text-center fw-bold"
              style={{ width: '50px' }}
            />
            <Button variant="outline-secondary" title="Ir para página" onClick={goto} disabled={pages === 1}>
              <FaCaretRight />
            </Button>
          </InputGroup>
        )}

        <Form.Select
          size="sm"
          id="limit"
          name="limit"
          value={manager.filter.limit}
          onChange={manager.filterMount('limit')}
          className="pagination-limit-select rounded-pill fw-semibold"
        >
          {limits.map((limit) => (
            <option key={limit} value={limit}>{`${limit} ${labels.records}`}</option>
          ))}
        </Form.Select>
      </div>

      <div className="d-flex align-items-center gap-1">
        <Button
          variant="light"
          className="btn-pagination-nav rounded-circle p-0 d-flex align-items-center justify-content-center"
          onClick={next}
          disabled={page === pages}
          title="Próxima Página"
        >
          <FaAngleRight size={13} />
        </Button>
        <Button
          variant="light"
          className="btn-pagination-nav rounded-circle p-0 d-flex align-items-center justify-content-center"
          onClick={last}
          disabled={page === pages}
          title="Última Página"
        >
          <FaAnglesRight size={13} />
        </Button>
      </div>
    </div>
  );

  const addFilters = () => (
    <Accordion className="not-printable rounded mb-1" defaultActiveKey={accordion} onSelect={(data) => { setAccordion(data); }}>
      <Accordion.Item eventKey="filters">
        <Accordion.Header>
          <FaMagnifyingGlass className="me-1" />
          Filtros
        </Accordion.Header>
        <Accordion.Body className="p-0 bg-light">
          <Form onSubmit={onSubmit}>
            <Row className="p-1 m-0 rounded">
              {filters?.length > 0 && !hideSaved && (
                <Col xs={12} className="mb-1">
                  <Form.Group className="mb-1">
                    <InputGroup size={config?.size ?? 'sm'}>
                      <Form.Select name="filters" size={config?.size ?? 'sm'} value={filter} onChange={handleFilter}>
                        <option value="">&#9735; Filtros salvos</option>
                        {filters.map((filter) => (
                          <option value={filter._id} key={filter._id}>{filter.name}</option>
                        ))}
                      </Form.Select>
                      {filter && selectedFilter.userId == user._id && (
                        <Button type="button" title="Editar Filtro" onClick={handleSaveFilter}>
                          <FaPencil />
                        </Button>
                      )}
                    </InputGroup>
                  </Form.Group>
                </Col>
              )}
              <Col className="mb-1">
                <Form.Group>
                  <InputGroup size={config?.size ?? 'sm'} className="search-input-group">
                    <span className="input-group-text bg-transparent border-0 ps-1 pe-2 text-muted fs-6 d-none d-sm-flex align-items-center">
                      <FaMagnifyingGlass />
                    </span>
                    <Form.Control id="term" name="term" type="text" value={term || manager.filter.term} onChange={handleInputChange} placeholder={placeholder || 'Digite o termo que deseja filtrar'} />
                    <Button type="submit" title="Pesquisar" className="btn-search-submit">
                      <FaMagnifyingGlass />
                      <span className="d-none d-sm-inline ms-1 fw-bold">Buscar</span>
                    </Button>
                    {exportable && (
                      <Button title="Exportar" onClick={manager.export}>
                        <FaFileExcel />
                      </Button>
                    )}
                    {hasFilter() && !hideClear && (
                      <>
                        <Button type="button" title="Limpar Filtro" onClick={handleClearFilter}>
                          <FaXmark />
                        </Button>
                        {!filter && !hideSaved && (
                          <Button type="button" title="Salvar Filtro" onClick={handleSaveFilter}>
                            <FaFloppyDisk />
                          </Button>
                        )}
                      </>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
              {custom}
            </Row>
          </Form>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );

  return (
    <div className="filter">
      {addFilters()}
      {main()}
      {total > 0 && (
        <Card className="records mb-1">
          <Card.Body className="not-printable">
            {paginate()}
            {records()}
          </Card.Body>
        </Card>
      )}
      {total === 0 && (
        <Card className="records-empty">
          <Card.Body>
            <div className="lead text-center m-0">{labels.empty}</div>
          </Card.Body>
        </Card>
      )}
      {children}
      {total > 0 && (
        <Card className="records mt-1 mb-1">
          <Card.Body className="not-printable">
            {records()}
            {paginate()}
          </Card.Body>
        </Card>
      )}
      {!ignoreMirror && total > 5 && addFilters()}
      {showFilterSaveModal && (
        <FilterSaveModal
          options={{
            show: showFilterSaveModal,
            key: manager.cacheKey,
            name: manager.name,
            filter: manager.filter,
            item: filters.find((el) => el._id === filter),
            hide: handleCancelSaveFilter,
            update: handleUpdate
          }}
        />
      )}
    </div>
  );
}
